import {
  ADD_SENDER,
  ADD_SENDER_FAIL,
  ADD_SENDER_SUCCESS,
  DELETE_SENDER,
  DELETE_SENDER_FAIL,
  DELETE_SENDER_SUCCESS,
  GET_SENDER_LIST,
  GET_SENDER_LIST_FAIL,
  GET_SENDER_LIST_SUCCESS,
  GET_SINGLE_SENDER,
  GET_SINGLE_SENDER_FAIL,
  GET_SINGLE_SENDER_SUCCESS,
  UPDATE_SENDER,
  UPDATE_SENDER_FAIL,
  UPDATE_SENDER_SUCCESS,
} from "src/constants/types";

export const senderReducer = (state = {}, actions) => {
  const { payload } = actions;
  switch (actions.type) {
    case GET_SENDER_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_SENDER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        senders: payload,
        error: "",
      };

    case GET_SENDER_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_SINGLE_SENDER:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_SENDER_SUCCESS:
      return {
        ...state,
        loading: false,
        selected_sender: actions.payload,
      };
    case GET_SINGLE_SENDER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_SENDER:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_SENDER_SUCCESS:
      return {
        ...state,
        loading: false,
        added_sender: actions.payload,
        error: "",
      };
    case ADD_SENDER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_SENDER:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_SENDER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_SENDER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_SENDER:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_SENDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_SENDER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
